import { createContext } from 'react';
import { Context } from './ChannelForm.types';

export const ChannelFormContext = createContext<Context>({} as Context);
